import AdminSession from './admin-session';
const AUTH_TOKEN = 'AUTH_TOKEN';
const REFRESH_TOKEN = 'REFRESH_TOKEN';
const REFERENCE_NUMBER = 'REFERENCE_NUMBER';
// Older Test bundles stored identity-provider payloads under this key. Delete
// the obsolete value without reading it; blocked storage must not prevent load.
const removeLegacyIdentityPayload = () => {
    try {
        localStorage.removeItem('SHUFFTIPRO');
    }
    catch {
        // Browser storage may be disabled. Do not inspect or log the payload.
    }
};
removeLegacyIdentityPayload();
const setAccessToken = (token) => {
    localStorage.setItem(AUTH_TOKEN, token);
};
const setRefreshToken = (token) => {
    localStorage.setItem(REFRESH_TOKEN, token);
};
const setReferenceNumber = (refNumber) => {
    localStorage.setItem(REFERENCE_NUMBER, refNumber);
};
// A strong admin session keeps its access token in memory only; it takes precedence over storage.
const getAccessToken = () => {
    return AdminSession.accessToken() ?? localStorage.getItem(AUTH_TOKEN);
};
const getRefreshToken = () => {
    return localStorage.getItem(REFRESH_TOKEN);
};
const getReferenceNumber = () => {
    return localStorage.getItem(REFERENCE_NUMBER);
};
const removeAccessToken = () => {
    localStorage.removeItem(AUTH_TOKEN);
};
const removeRefreshToken = () => {
    localStorage.removeItem(REFRESH_TOKEN);
};
const removeReferenceNumber = () => {
    localStorage.removeItem(REFERENCE_NUMBER);
};
const LocalStorageService = {
    removeLegacyIdentityPayload,
    setAccessToken,
    setRefreshToken,
    setReferenceNumber,
    getAccessToken,
    getRefreshToken,
    getReferenceNumber,
    removeAccessToken,
    removeRefreshToken,
    removeReferenceNumber
};
export default LocalStorageService;
